import fgApi from '@/services/fillgoods'
export default {
    methods: {
        async getAllContentTitle () {
            try {
                let res = await fgApi.cms.getLearningContentTitle()
                if (res.success) {
                    return res.data
                } else {
                    this.notifyLearningCenter('Get data fail!!', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            return []
        },
        async filterSubTitleFormHtmlTag (detail) {
            let text = detail.html.toString()
            let matchText = text.toString().match(/<h3(.*?)>(.*?)<\/h3>/g)
            let textResultFromApi = []
            let result = []
            if (matchText) {
                result = matchText.map((word, index) => {
                    return {
                        id: index,
                        text: word.replace(/<\/?h3>/g, '').replace(/&nbsp;/g, '')
                    }
                })
            }
            textResultFromApi = await this.getAllContentTitle()
            textResultFromApi.forEach((e, idx, self) => {
                if (e.learningCenterId === detail.learningCenterId) {
                    self[idx] = { ...detail, subTitle: result }
                }
            })
            return textResultFromApi
        },
        async updateTextContentInfo (detail, type) {
            try {
                let param = {
                    learningCenterId: detail.learningCenterId,
                    title: detail.title,
                    html: detail.html,
                    isPublish: detail.isPublish
                }
                let res = await fgApi.cms.updateLearningContent(param)
                if (res.success) {
                    if (type !== '') {
                        this.notifyLearningCenter(`${type} complete`, 'success')
                    }
                    return this.filterSubTitleFormHtmlTag(detail)
                } else {
                    this.notifyLearningCenter('Update data fail', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            return []
        },
        notifyLearningCenter (text, type) {
            this.$notify({
                message: text,
                type: type,
                showClose: false,
                customClass: 'cms-notify-style'
            })
        }
    }
}
